/// <amd-module name="Feed/Legacy/Protocols/Ivy/IvyPackagePeople" />
import * as React from "react";

import { IVssPageContext } from "VSS/Platform/Context";

import { IvyXmlRef } from "Feed/Common/Protocols/Ivy/Contracts/Ivy";
import * as PackageResources from "Feed/Common/Resources";
import { IPerson } from "Feed/Legacy/Protocols/Common/IPerson";
import { PackageAttribute } from "Feed/Legacy/Protocols/Components/PackageAttribute";
import { PackagePerson } from "Feed/Legacy/Protocols/Components/PackagePerson";

export interface IIvyPackagePeopleProps {
    pageContext: IVssPageContext;
    authors: IvyXmlRef[];
}

export class IvyPackagePeople extends React.PureComponent<IIvyPackagePeopleProps> {
    public render(): JSX.Element {
        return (
            this.props.authors &&
            this.props.authors.length > 0 && (
                <div className="ivy-package-people">
                    <PackageAttribute title={PackageResources.IvyPackagePeople_Authors}>
                        {this.props.authors.map((author: IvyXmlRef) => {
                            return (
                                <PackagePerson
                                    pageContext={this.props.pageContext}
                                    key={author.name}
                                    person={this.ToPerson(author)}
                                />
                            );
                        })}
                    </PackageAttribute>
                </div>
            )
        );
    }

    private ToPerson(author: IvyXmlRef): IPerson {
        const href = author.url;
        const isEmail = href && href.indexOf("@") != -1;
        return {
            name: author.name,
            email: isEmail ? href : null,
            url: isEmail ? null : href ? href : null
        } as IPerson;
    }
}
